import script from "./SearchGroupInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchGroupInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchGroupInput.vue?vue&type=style&index=0&id=0fc420ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc420ba"]])

export default __exports__